import { render, staticRenderFns } from "./courseHome.vue?vue&type=template&id=493de2ab"
import script from "./courseHome.vue?vue&type=script&lang=js"
export * from "./courseHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports